import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { KustoDataset } from 'app/model/dataset/kusto.dataset';
import { DatasetAdapter } from 'app/model/adapters/datasets/dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
            }
        }
    }
})
export class KustoDatasetAdapter extends DatasetAdapter<KustoDataset, Model.DatasetResource> {
    protected async _toResource(dataset: KustoDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.KustoDataset;
        modelDataset.type = Metamodel.modelFor(KustoDataset).name;
        modelDataset.structure = this.columnValueToResource(dataset, dataset.columns);
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: KustoDataset): Promise<KustoDataset> {
        if (!dataset) {
            dataset = KustoDataset.MODEL.create<KustoDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.KustoDataset;
        if (model) {
            dataset.columns = this.columnResourceToValue(dataset, model.structure);
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, KustoDataset.MODEL));
        return dataset;
    }
}
